module.exports = __webpack_public_path__ + "static/img/result.dfcce9b6.webp";